<template>
  <div class="layoutDefault">
    <div class="flex mt-10 justify-center relative z-10 xs:hidden md:flex">
      <div class="mr-4">
        <svg-menu class="text-center" />
      </div>

      <div>
        <span class="text-black text-2xl font-medium">Main Menu</span>
      </div>
    </div>

    <div style="max-width: 964px" class="mx-auto overflow-hidden overflow-x-auto">
      <div class="flex w-full justify-between">
        <div
          class="group sm:relative mt-3 px-8 py-7 text-center z-10 menu-ticket hover:bg-base-300"
          v-for="m in menus"
          :key="m.id"
          @click="toPage(m.to)"
        >
          <div class="flex justify-center" style="height: 41px">
            <img class="self-end" :src="m.icon" style="margin-right: auto; margin-left: auto" />
          </div>
          <p class="font-medium mt-2 text-lg">{{ m.label }}</p>
          <p class="h-menu-sub whitespace-nowrap">{{ m.sublabel }}</p>

          <p
            class="xs:hidden sm:block h-0 w-full absolute left-0 transition-opacity opacity-0 group-hover:opacity-100"
            style="bottom: -1.2px; border: 3px solid #ff0701"
          ></p>
        </div>
      </div>
      <div class="h-0 w-full relative xs:hidden sm:block" style="border: 1px solid #adadad"></div>
    </div>

    <div
      style="max-width: 964px"
      class="mx-auto mt-12 flex-col md:flex-row flex gap-6 relative z-10"
    >
      <div class="w-full sm:w-2/3" :class="menuNews ? '' : 'hidden'">
        <div class="h-sosmed-card pt-4">
          <div class="flex items-center space-x-2 px-4">
            <IconNewsRounded class="h-6 w-6" />
            <span class="text-lg font-bold">News</span>
          </div>

          <div class="flex items-center overflow-x-auto mt-4">
            <div
              v-for="c in categories"
              :key="c.id"
              class="px-6 py-2 font-Roboto cursor-pointer hover:bg-gray-100 hover:text-gray-700 rounded-t whitespace-nowrap"
              :class="
                c.id == category
                  ? 'border-gray-500 border-b-4 text-gray-500'
                  : 'border-b border-gray-200 text-gray-400'
              "
              @click="category = c.id"
            >
              {{ c.name }}
            </div>
          </div>

          <div class="mt-2 flex flex-col">
            <div class="p-5 border-b border-gray-100" v-for="item in news" :key="item.id">
              <div
                v-html="item.description"
                class="line-clamp-2 cursor-pointer [&_iframe]:hidden [&_img]:hidden"
                @click="MODAL_NEWS(item)"
              ></div>
              <div v-if="item.file_url.length" class="mt-2 rounded">
                <img
                  v-if="item.file_url[0].file_type == 'image'"
                  :src="item.file_url[0].file_path"
                  class="rounded-lg cursor-pointer"
                  @click="MODAL_NEWS(item)"
                />
                <video v-else :src="item.file_url[0].file_path" controls class="rounded-lg"></video>
              </div>
              <div class="flex items-center justify-between space-x-1 mt-2.5">
                <div class="flex items-center space-x-5">
                  <div class="flex items-center space-x-2 cursor-pointer" @click="toLiked(item.id)">
                    <IconLike
                      class="h-6 w-6"
                      :class="item.is_like ? 'text-blue-500' : 'text-gray-400'"
                    />
                    <span class="text-gray-500 text-sm font-medium">{{ item.likes_count }}</span>
                  </div>
                  <div class="flex items-center space-x-2 cursor-pointer" @click="MODAL_NEWS(item)">
                    <IconComment class="h-6 w-6 text-gray-400" />
                    <span class="text-gray-500 text-sm font-medium">{{ item.comments_count }}</span>
                  </div>
                </div>

                <div
                  class="flex items-center space-x-3 overflow-x-auto cursor-pointer w-full justify-end"
                  @click="MODAL_NEWS(item)"
                >
                  <div class="text-gray-500 text-sm font-medium">
                    {{ item.published_at | moment('DD MMM YYYY') }}
                  </div>
                  <div class="rounded px-1.5 py-0.5 text-sm font-medium bg-gray-100 text-gray-500">
                    {{ item.category_name }}
                  </div>
                </div>
              </div>
            </div>

            <button
              v-if="news && news.length > 0"
              @click="toPage('news.index')"
              class="mx-auto my-5 rounded-lg border border-gray-100 py-2 px-3 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-600"
            >
              Click more detail...
            </button>

            <div v-else class="mx-auto flex flex-col my-5">
              <IconNonews class="h-20 w-24 mx-auto" />
              <span class="text-center text-gray-600 font-Roboto"
                >Check back later for updates</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex gap-11"
        :class="menuNews ? 'flex-col flex-auto' : 'flex-col sm:flex-row mx-auto'"
      >
        <div class="h-99" :class="loading ? 'animate-pulse' : ''">
          <div class="h-ticket-card">
            <div class="flex items-center justify-between pb-1.5 border-b border-gray-200 my-3">
              <span class="text-sm font-medium">Ticket Done</span>
              <span class="text-sm font-semibold px-1 rounded bg-gray-100">{{
                ticketDone.length
              }}</span>
            </div>
            <div class="grid grid-flow-row stats" v-if="ticketDone && ticketDone.length">
              <my-scroll :ops="opts" ref="vt">
                <div
                  class="stat px-2 py-2"
                  v-for="td in ticketDone"
                  :key="td.id"
                  :class="td.status == 'closed' ? '' : 'hover:bg-hgray6 cursor-pointer'"
                  @click="toDetail(td)"
                >
                  <span class="text-sm font-medium">{{ td.number }}</span>

                  <button
                    class="btn btn-outline capitalize btn-ticket-close absolute hover:border-transparent right-2"
                  >
                    Done
                  </button>
                </div>
              </my-scroll>
            </div>
            <div class="grid grid-flow-row stats" v-else>
              <IconNoTicket class="mx-auto mt-20" />
              <div class="text-htext text-center font-semibold">There is no ticket yet!</div>
            </div>
          </div>
        </div>
        <div class="h-99" :class="loading ? 'animate-pulse' : ''">
          <div class="h-ticket-card">
            <div class="flex items-center justify-between pb-1.5 border-b border-gray-200 my-3">
              <span class="text-sm font-medium">Ticket Progress</span>
              <span class="text-sm font-semibold px-1 rounded bg-gray-100">{{
                ticketProgress.length
              }}</span>
            </div>

            <div class="grid grid-flow-row stats" v-if="ticketProgress && ticketProgress.length">
              <my-scroll :ops="opts" ref="vt">
                <div
                  class="stat pl-0 pr-1 py-2 cursor-pointer hover:bg-hgray6"
                  v-for="tp in ticketProgress"
                  :key="tp.id"
                  @click="toDetail(tp)"
                >
                  <div>
                    <div class="ticket-progress-label">{{ tp.number }}</div>

                    <div class="flex mt-1">
                      <div class="flex" v-if="tp.assigneeName">
                        <svg-pic-xs class="ml-2 mr-1 w-2.3 h-2.3" />
                        <span class="ticket-progress-sublabel">{{ tp.assigneeName }}</span>
                      </div>

                      <div class="flex" v-if="tp.created_at">
                        <IconTime class="mr-1 ml-3 w-2.3 h-2.3" />
                        <span class="ticket-progress-sublabel">
                          {{ tp.created_at.date | moment('D/MM/YYYY') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <img v-if="tp.status == 'new'" :src="StatusNew" />
                    <img v-if="tp.status == 'confirmed'" :src="StatusConfirmed" />
                    <img v-if="tp.status == 'started'" :src="StatusStarted" />
                    <img v-if="tp.status == 'held'" :src="StatusOnHold" />
                    <img v-if="tp.status == 'restarted'" :src="StatusRestarted" />
                  </div>
                </div>
              </my-scroll>
            </div>
            <div class="grid grid-flow-row stats" v-else>
              <IconNoTicket class="mx-auto mt-20" />
              <div class="text-htext text-center font-semibold">There is no ticket yet!</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconTicket from '@/assets/icons/icon-openTicket.svg'
import IconMyTicket from '@/assets/icons/icon-myTicket.svg'
import IconInstrument from '@/assets/icons/icon-instruments.svg'
import IconListPlan from '@/assets/icons/icon-plannings.svg'
import IconBot from '@/assets/icons/icon-bot.svg'
import IconArchive from '@/assets/icons/icon-archive.svg'
import IconNews from '@/assets/icons/icon-news.svg'
import IconNewsRounded from '@/assets/icons/icon-news-rounded.svg?inline'
import IconComment from '@/assets/icons/icon-comment.svg?inline'
import IconLike from '@/assets/icons/icon-like.svg?inline'
import IconNonews from '@/assets/icons/icon-nonews.svg?inline'

import StatusNew from '@/assets/images/icon-new.png'
import StatusConfirmed from '@/assets/images/icon-confirmed.png'
import StatusStarted from '@/assets/images/icon-started.png'
import StatusOnHold from '@/assets/images/icon-onhold.png'
import StatusRestarted from '@/assets/images/icon-restarted.png'

import SvgMenu from '@/assets/icons/icon-menu.svg?inline'
import SvgPicXs from '@/assets/icons/icon-picTicket.svg?inline'
import IconTime from '@/assets/icons/icon-timeColored.svg?inline'
import IconNoTicket from '@/assets/icons/icon-noTicket.svg?inline'

import { mapActions, mapState } from 'vuex'

import { sosmedCategoryIndex, sosmedPostIndex, sosmedPostLiked } from '@/services/apiSosmed'

export default {
  name: 'home',
  components: {
    SvgPicXs,
    SvgMenu,
    IconNoTicket,
    IconTime,
    IconNewsRounded,
    IconComment,
    IconLike,
    IconNonews
  },
  data() {
    return {
      StatusNew,
      StatusConfirmed,
      StatusStarted,
      StatusOnHold,
      StatusRestarted,
      IconTicket,
      IconMyTicket,
      IconInstrument,
      IconListPlan,
      IconBot,
      IconArchive,
      IconNews,
      opts: {
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'number',
          detectResize: true,
          locking: true
        },
        scrollPanel: {
          scrollingX: false,
          scrollingY: true,
          verticalNativeBarPos: 'right',
          maxHeight: 345
        },
        bar: {
          background: '#176FA9',
          opacity: 1,
          size: '5px',
          minSize: 0.2
        }
      },
      ticketProgress: [],
      ticketDone: [],
      loading: false,
      category: 0,
      categories: [
        {
          id: 0,
          name: 'All'
        }
      ],
      news: [],
      countLike: 0
    }
  },
  computed: {
    ...mapState({
      ticketTime: state => state.ticket.ticketTime,
      modalBot: state => state.modal.bot,
      haveInstrument: state => state.auth.haveInstrument,
      user: state => state.auth.user
    }),
    menus: function () {
      let temp = [
        {
          id: 'open',
          label: 'Open Ticket',
          sublabel: 'Create your ticket here',
          icon: this.IconTicket,
          to: 'open.intro'
        },
        // {
        //   id: 'news',
        //   label: 'News',
        //   sublabel: 'Latest news and updates',
        //   icon: this.IconNews,
        //   to: 'news.index'
        // },
        {
          id: 'my',
          label: 'My Ticket',
          sublabel: 'Manage your ticket here',
          icon: this.IconMyTicket,
          to: 'ticket.index'
        },
        {
          id: 'instrument',
          label: 'Instruments',
          sublabel: 'List of instruments used',
          icon: this.IconInstrument,
          to: 'instrument.index'
        },
        {
          id: 'planning',
          label: 'Plannings',
          sublabel: 'Schedule plan list',
          icon: this.IconListPlan,
          to: 'planning.index'
        },
        {
          id: 'archive',
          label: 'Archives',
          sublabel: 'Document Report File',
          icon: this.IconArchive,
          to: 'archive.index'
        }
      ]

      if (this.haveInstrument)
        temp.unshift({
          id: 'bot',
          label: 'Support Assistant',
          sublabel: 'Chat support virtual assistants',
          icon: this.IconBot,
          to: 'bot'
        })

      return temp
    },
    menuNews: function () {
      return process.env.VUE_APP_MENU_NEWS == 1 ? true : false
    }
  },
  watch: {
    ticketTime: function () {
      this.getTickets()
    },
    category: function () {
      this.getNews({ category_id: this.category, per_page: 5 })
    }
  },
  mounted() {
    this.getTickets()
    this.CHECK_INSTRUMENTS()

    this.getCategory()
    this.getNews({ category_id: this.category, per_page: 5 })
  },
  methods: {
    ...mapActions('ticket', ['GET_TICKETS', 'TICKET_DETAIL']),
    ...mapActions('modal', ['MODAL_BOT', 'MODAL_NEWS']),
    ...mapActions('auth', ['CHECK_INSTRUMENTS']),
    toPage(val) {
      if (val == 'open.technical') this.$router.push({ name: val, params: { id: 1 } })
      else if (val == 'ticket.index')
        this.$router.push({
          name: val,
          query: { offset: 0, limit: 9, ticket_type: 0 }
        })
      else if (val == 'bot') this.MODAL_BOT(!this.modalBot)
      else this.$router.push({ name: val })
    },
    async getTickets() {
      this.loading = true
      let p = await this.GET_TICKETS({
        statuses: 'new,restarted,started,held,confirmed',
        offset: 0,
        limit: 50
      })
      if (p) this.ticketProgress = p

      let d = await this.GET_TICKETS({ statuses: 'done,closed' })
      if (d) this.ticketDone = d

      this.loading = false
    },
    toDetail(val) {
      if (val.status != 'closed') {
        let removeSpacing = val.number ? val.number.replaceAll(/\s+/g, '-') : ''
        let removeSlash = removeSpacing.replaceAll('/', '')
        this.$router.push({ name: 'ticket.detail', params: { slug: removeSlash, id: val.id } })
      }
    },
    async getCategory() {
      let res = await sosmedCategoryIndex()
      this.categories = [...this.categories, ...res.data]
    },
    async getNews(params) {
      let res = await sosmedPostIndex(params)
      this.news = res.data
    },
    async toLiked(id) {
      if (this.countLike) return

      this.countLike = 1

      let res = await sosmedPostLiked({
        post_id: id
      })
      if (res) {
        this.news = this.news.map(news => {
          if (news.id === id) {
            news.is_like = res.data.is_like == false ? 0 : 1
            news.likes_count =
              res.data.is_like == false ? news.likes_count - 1 : news.likes_count + 1
          }
          return news
        })
      }

      setTimeout(() => {
        this.countLike = 0
      }, 3000)
    }
  }
}
</script>
